import {useEffect,useRef,useState} from "react";
import {lookupPostalCities} from "../services/postalCities";
const cityKey=value=>String(value||"").normalize("NFD").replace(/[\u0300-\u036f]/g,"").toLowerCase().replace(/\bsaint\b/g,"st").replace(/[^a-z0-9]+/g," ").trim();
export const sameCity=(a,b)=>Boolean(cityKey(a)) && cityKey(a)===cityKey(b);
export function usePostalCities({postCode,town,onTownChange,enabled=true}) {
 const [cities,setCities]=useState([]),[loading,setLoading]=useState(false),[error,setError]=useState("");
 const latest=useRef({town,onTownChange});latest.current={town,onTownChange};
 const previousCode=useRef(String(postCode||""));
 useEffect(()=>{
  const code=String(postCode||"").trim();
  const changed=previousCode.current!==code;previousCode.current=code;
  setCities([]);setError("");setLoading(false);
  if(!enabled || !/^\d{5}$/.test(code))return;
  const initialTown=latest.current.town;
  const controller=new AbortController();let active=true;
  const timer=setTimeout(async()=>{
   setLoading(true);
   const timeout=setTimeout(()=>controller.abort(),8000);
   try {
    const result=await lookupPostalCities(code,{signal:controller.signal});
    if(!active)return;
    setCities(result);
    // Never replace a manually edited city while the request is running.
    if(latest.current.town!==initialTown || result.includes(initialTown) || (!changed && initialTown))return;
    const same=result.find(city=>sameCity(city,initialTown));
    if(same)latest.current.onTownChange(same);
    else if(result.length===1)latest.current.onTownChange(result[0]);
    else if(result.length>1)latest.current.onTownChange("");
   }catch{if(active)setError("Villes indisponibles — saisie manuelle possible.");}
   finally{clearTimeout(timeout);if(active)setLoading(false);}
  },250);
  return ()=>{active=false;clearTimeout(timer);controller.abort();};
 },[postCode,enabled]);
 return {cities,loading,error};
}
